var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { title: _vm.$t("lbl_insurance_amortize_report") } },
    [
      _c(
        "a-row",
        [
          _c(
            "a-form",
            {
              attrs: {
                layout: "vertical",
                form: _vm.form,
                "label-col": { span: 8 },
                "wrapper-col": { span: 14 }
              }
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.$t(_vm.formRules.unitCode.label) }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.unitCode.decorator,
                                  expression: "formRules.unitCode.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.$t(_vm.formRules.unitCode.name),
                                placeholder: _vm.$t(
                                  _vm.formRules.unitCode.placeholder
                                ),
                                showSearch: true,
                                allowClear: true,
                                loading: _vm.loading.unitCode,
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption
                              },
                              on: {
                                search: function(value) {
                                  return _vm.searchData(value, "unitCode")
                                }
                              }
                            },
                            _vm._l(_vm.dataListUnitCode, function(data, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: data.name } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          " " + _vm._s("" + data.name) + " "
                                        )
                                      ]),
                                      _vm._v(" " + _vm._s("" + data.name) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.leasingNumber.label)
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.leasingNumber.decorator,
                                  expression:
                                    "formRules.leasingNumber.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.$t(_vm.formRules.leasingNumber.name),
                                placeholder: _vm.$t(
                                  _vm.formRules.leasingNumber.placeholder
                                ),
                                showSearch: true,
                                allowClear: true,
                                loading: _vm.loading.leasingNumber,
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption
                              },
                              on: {
                                search: function(value) {
                                  return _vm.searchData(value, "leasingNumber")
                                }
                              }
                            },
                            _vm._l(_vm.dataListLeasingNumber, function(
                              data,
                              index
                            ) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: data.name } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          " " + _vm._s("" + data.name) + " "
                                        )
                                      ]),
                                      _vm._v(" " + _vm._s("" + data.name) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.policyNumber.label)
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.policyNumber.decorator,
                                  expression: "formRules.policyNumber.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.$t(_vm.formRules.policyNumber.name),
                                placeholder: _vm.$t(
                                  _vm.formRules.policyNumber.placeholder
                                ),
                                showSearch: true,
                                allowClear: true,
                                loading: _vm.loading.policyNumber,
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption
                              },
                              on: {
                                search: function(value) {
                                  return _vm.searchData(value, "policyNumber")
                                }
                              }
                            },
                            _vm._l(_vm.dataListPolicyNumber, function(
                              data,
                              index
                            ) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: data.id } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s("" + data.id) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s("" + data.id) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.insuranceName.label)
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.insuranceName.decorator,
                                  expression:
                                    "formRules.insuranceName.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.$t(_vm.formRules.insuranceName.name),
                                placeholder: _vm.$t(
                                  _vm.formRules.insuranceName.placeholder
                                ),
                                showSearch: true,
                                allowClear: true,
                                loading: _vm.loading.insuranceName,
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption
                              },
                              on: {
                                search: function(value) {
                                  return _vm.searchData(value, "insuranceName")
                                }
                              }
                            },
                            _vm._l(_vm.dataListInsuranceName, function(
                              data,
                              index
                            ) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: data.id } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          " " + _vm._s("" + data.name) + " "
                                        )
                                      ]),
                                      _vm._v(" " + _vm._s("" + data.name) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.periodFrom.label)
                          }
                        },
                        [
                          _c("a-date-picker", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.periodFrom.decorator,
                                expression: "formRules.periodFrom.decorator"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              name: _vm.$t(_vm.formRules.periodFrom.name),
                              placeholder: _vm.$t(
                                _vm.formRules.periodFrom.placeholder
                              ),
                              format: _vm.DEFAULT_DATE_FORMAT
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.$t(_vm.formRules.periodTo.label) }
                        },
                        [
                          _c("a-date-picker", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.periodTo.decorator,
                                expression: "formRules.periodTo.decorator"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              name: _vm.$t(_vm.formRules.periodTo.name),
                              placeholder: _vm.$t(
                                _vm.formRules.periodTo.placeholder
                              ),
                              format: _vm.DEFAULT_DATE_FORMAT
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      staticClass: "mt-2 mb-2",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: {
                            width: "180px",
                            "margin-right": "1rem"
                          },
                          attrs: { type: "danger" },
                          on: { click: _vm.clear }
                        },
                        [_vm._v(" " + _vm._s(this.$t("lbl_reset")) + " ")]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: {
                            width: "180px",
                            "margin-right": "1rem"
                          },
                          attrs: { type: "primary", loading: _vm.loading.find },
                          on: {
                            click: function($event) {
                              return _vm.findData(false)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(this.$t("lbl_find")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-col",
            { staticClass: "mt-4", attrs: { span: 24 } },
            [
              _c("TableCustom", {
                attrs: {
                  idtable: "table1",
                  dataSource: _vm.dataSource.data,
                  columns: _vm.columnsTable,
                  onSelectChange: null,
                  selectedRowKeys: null,
                  scroll: { x: "calc(700px + 50%)", y: 400 },
                  paginationcustom: true,
                  defaultPagination: false
                }
              })
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c("Pagination", {
                attrs: {
                  total: _vm.dataSource.totalElements,
                  pageSizeSet: _vm.limit,
                  idPagination: "pagination1"
                },
                on: {
                  "response-pagesize-change": _vm.responsePageSizeChange,
                  "response-currentpage-change": _vm.responseCurrentPageChange
                }
              })
            ],
            1
          ),
          _c(
            "a-col",
            { staticClass: "mt-3", attrs: { span: 12, align: "end" } },
            [
              _c(
                "a-tag",
                {
                  staticStyle: { "font-size": "13px" },
                  attrs: { color: "grey" }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("lbl_total_found")) +
                      " : " +
                      _vm._s(_vm.dataSource.totalElements) +
                      " "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "a-col",
            { staticClass: "mt-2", attrs: { span: 24, align: "end" } },
            [
              _c(
                "a-button",
                {
                  staticStyle: { "margin-right": "0.5rem" },
                  attrs: {
                    type: "primary",
                    loading: _vm.loading.download,
                    disabled:
                      _vm.dataSource.data && _vm.dataSource.data.length
                        ? false
                        : true
                  },
                  on: { click: _vm.download }
                },
                [_vm._v(" " + _vm._s(_vm.$t("lbl_download")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }